export default __webpack_public_path__ + "static/media/UT8000.b8873df9.png";